﻿import * as Res from "./res";
import { FS } from "./_fs";
import { initForm, initDeps, setFocus } from "./dynrefresh";
import { createElement, onEvent, unsafeSetHTML, findChild, findChildren } from "./_dom";
import { init as initToolbuttons } from "./actionButtons";
import { dbfetch } from "./dbfetch";

const data_rowedit_attr = "data-td-rowedit-disable";

// disable interactive controls
function beforeRequest(tr) {
	const form = tr.closest("form");
	const cd = form.querySelectorAll(".ui-button,input[type=\"checkbox\"]");
	cd.forEach(e => {
		if (!e.hasAttribute("disabled")) {
			e.setAttribute(data_rowedit_attr, "");
			e.setAttribute("disabled", "");
		}
	});
}

function completeRequest(tr) {
	const form = tr.closest("form");
	const cd = form.querySelectorAll(".ui-button[" + data_rowedit_attr + "],input[type=\"checkbox\"][" + data_rowedit_attr + "]");
	cd.forEach(e => {
		e.removeAttribute("disabled");
	});
}

function setRowHtml(tr, data) {
	// x should probably hold the reference to the row element.
	// eslint-ignore-next-line no-unused-vars
	var x, trp = tr.parentNode;
	if (data.html) {
		// const x = fragment.content.firstElementChild
		unsafeSetHTML(tr, data.html/*x*/, "replace");
		// attach toolactions
		initToolbuttons(x);
	}
	else {
		tr.remove();
	}
	completeRequest(trp);
	return x;
}

function setRowData(tr, data, ts) {
	var td = tr.querySelector("td");
	for (const [x, { type, value, html }] of Object.entries(data.record)) {
		td = td.nextElementSibling;
		if (!td) break;
		tr.prepend(createElement("input", { name: "o_" + x, type: "hidden", value }));
		const el = createElement("div", { id: x + "_value", "class": [ "v3-gridlayout-cell__value", type == 2 && " v3-state-required" ] });
		td.replaceChildren(el);
		unsafeSetHTML(el, html);
	}
	if (ts) {
		tr.prepend(createElement("input", { name: "ts", type: "hidden", value: ts }));
	}
}

function setErrors(tr, c) {
	if (c != null && c.length) {
		const td = createElement("td", { "class": "v3-tableview__group-col", colspan: 255 });
		for (var i = 0; i < c.length; i++) {
			const div = createElement("div", { "class": "ui-alert ui-icon-error" }, c[i]);
			td.append(div);
		}
		const trErr = createElement("tr", { "class": [ "v3-tableview__group-row v3-state-row-error",  tr.classList.contains("fs-odd") && "fs-odd" ] });
		trErr.append(td);
		tr.after(trErr);
	}
}

function removeErrors(tr) {
	tr.querySelectorAll("td div.ui-alert.ui-icon-error").forEach(td => td.remove());
	if (tr.nextElementSibling?.matches("tr.v3-state-row-error")) {
		tr.nextElementSibling.remove();
	}
}

function onAjaxError(tr, errorThrown) {
	setErrors(tr, [errorThrown.toString()]); // create error row, remove it after 5 seconds
	setTimeout(() => {
		if (tr.nextElementSibling?.matches("tr.v3-state-row-error")) {
			tr.nextElementSibling.remove();
		}
	}, 5000);
}

function makeUrl(url, options) {
	url = new URL(url);
	for (var [k, v] of Object.entries(options))
		url.searchParams.set(k, v);
	return url.toString();
}

function enableSaveCancel(tr, value) {
	const buttons = findChildren(findChild(findChild(tr, "td"), "nobr"), "button");
	buttons.forEach(b => b.disabled = !value);
}

function updateLayout() {
	window.dispatchEvent(new Event('resize'));
}

function serialize(element, submitter, selector = "input[name]:not(:disabled),select[name]:not(:disabled),textarea[name]:not(:disabled)") {
	const result = new FormData();
	element.querySelectorAll(selector).forEach(e => {
		if (e.name != null && e.name != "" && !e.disabled) {
			if (e.tagName === "INPUT") {
				if (e.type === "radio" || e.type === "checkbox") {
					if (e.checked)
						result.append(e.name, e.value);
				} else if (e.type === "submit" || e.type === "image") {
					if (e === submitter)
						result.append(e.name, e.value ?? "");
				} else if (e.type === "reset") {
					// buttons, do nothing
				} else if (e.type === "file") {
					for (let i = 0; i < e.files.length; i++) {
						result.append(e.name, e.files[i], e.files[i].name);
					}
				} else {
					result.append(e.name, e.value);
				}
			} else if (e.tagName === "BUTTON") {
				if (e.type == "submit" && e === submitter) {
					result.append(e.name, e.value ?? "");
				}
			} else {
				result.append(e.name, e.value);
			}
		}
	});
	return result;
}


async function saveRow(tr, baseUrl, callback) {
	removeErrors(tr); // remove previous errors
	baseUrl = makeUrl(baseUrl, { cmd: "rowsave" });
	var formData = serialize(tr);
	enableSaveCancel(tr, false);

	var trTop = tr.getBoundingClientRect().top;

	try {
		var response = await dbfetch(baseUrl, { method: "POST", body: formData });
		if (!response.ok)
			throw new Error(`${response.status} ${response.statusText}`);
		const data = await response.json();
		var tfoots = findChildren(tr.closest("table"),"tbody.v3-tableview__groupfoot");
		enableSaveCancel(tr, true);
		var ctx = saveComplete(tr, data);
		if (ctx !== false) {
			tfoots.forEach(tfoot => tfoot.classList.add("v3-tableview__groupfoot--invalid"));
			if (ctx != null) window.scrollBy(0, ctx.getBoundingClientRect().top - trTop);
			callback?.(true);
		}
	} catch (e) {
		enableSaveCancel(tr, true);
		setErrors(tr, [e.toString()]);
	}
	updateLayout();
}

function saveComplete(tr, data) {
	var err;
	if (data.html != null) {
		return setRowHtml(tr, data);
	}
	else if ((err = data.controldata.invalid)) {
		// any errors?
		var c = err.common || [];
		for (var f in err) {
			if (f != "common") {
				var fe = document.getElementById(f + "_value");
				if (fe) {
					// if cell is found
					var errDiv = fe.querySelector("div.v3-layout-cell__error");
					if (!errDiv) {
						fe.append(errDiv = createElement("div", { "class": "v3-gridlayout-cell__error v3-layout-cell__error v3-error" }));
					}
					errDiv.replaceChildren(err[f]);
				}
				else // add to common errors
					c.push(err[f]);
			}
		}
		setErrors(tr, c);
		return false;
	}
}

async function cancelRow(tr, baseUrl, callback) {
	removeErrors(tr);
	if (!tr.matches(".v3-tableview__group-row--new")) { // new row? do not query
		var trTop = tr.getBoundingClientRect().top;
		baseUrl = makeUrl(baseUrl, { cmd: "rowcancel" });
		enableSaveCancel(tr, false);
		try {
			const response = await dbfetch(baseUrl);
			if (!response.ok)
				throw new Error(`${response.status} ${response.statusText}`);
			const data = await response.json();
			enableSaveCancel(tr, true);
			var ctx = setRowHtml(tr, data);
			if (ctx != null)
				window.scrollBy(0, ctx.getBoundingClientRect().top - trTop);
			callback?.(false);
		} catch (e) {
			enableSaveCancel(tr, true);
			onAjaxError(tr, e);
		} finally {
			updateLayout();
		}
	} else {
		setRowHtml(tr, { html: "" });
		callback?.(false);
		updateLayout();
	}
}

async function startEdit(tr, baseUrl, callback) {
	// disable form controls
	beforeRequest(tr);

	// note row's vertical position
	var trTop = tr.getBoundingClientRect().top;

	// perform GET for the editors HTML code
	try {
		const response = await dbfetch(baseUrl);
		if (!response.ok)
			throw new Error(`${response.status} ${response.statusText}`);
		const data = await response.json();
		tr.style.backgroundColor = "";
		tr.style.color = "";
		const buttons = tr.querySelector(".v3-buttonbar");
		buttons.replaceChildren(
			createElement("button", {
				type: "submit",
				"class": "ui-button v3-button ui-action-save v3-button-default",
				onclick: event => {
					event.preventDefault();
					saveRow(tr, baseUrl, callback);
				}
			}, Res.getString("action.save")),
			createElement("button", {
				type: "reset",
				"class": "ui-button v3-button ui-action-cancel",
				onclick: event => {
					event.preventDefault();
					cancelRow(tr, baseUrl, callback);
				}
			}, Res.getString("action.cancel")));
		setRowData(tr, data, data.controldata.ts);
		FS.Form.init(tr);
		initDeps(tr, data.controldata);
		initForm(tr);
		window.scrollBy(0, tr.getBoundingClientRect().top - trTop);
		setFocus(tr);
	} catch (e) {
		callback?.(false);
		completeRequest(tr);
		onAjaxError(tr, e);
	} finally {
		updateLayout();
	}
}

function cleanupFakeActionCol(table) {
	if (table.classList.contains("v3-tableview__fake-action")) {
		// fake action column was added and we have to cleanup
		table.querySelectorAll(".v3-tableview__fake-action-col").forEach(cell => cell.remove());
		table.querySelectorAll(".v3-tableview__fake-action-colspan").forEach(cell => cell.colSpan--);
		table.classList.remove("v3-tableview__fake-action");
	}
}

function makeStartEditCallback(newTr, emptyTr, callback) {
	return success => {
		const table = newTr.closest("table");
		if (success) {
			emptyTr?.remove();
		}
		else {
			newTr.remove();
			emptyTr?.classList.remove("hide");
		}
		callback?.(success);
	};
}

/**
 * 
 * @param {HTMLTableElement} table
 * @param {string} url
 * @param {any} callback
 * @returns
 */
function startNewEdit(table, url, callback) {
	const hasActionCol = table.tHead?.rows[0]?.cells[0]?.classList.contains("v3-actioncol");
	if (!hasActionCol) {
		// table has no action col, but we need it to render save/cancel buttons
		// let's add it to every row in the table
		// this is needed only for newRows
		table.classList.add("v3-tableview__fake-action");
		table?.tHead.rows[0]?.prepend(createElement("th", {
				width: 1,
				class: "v3-tableview__head-col v3-tableview__head-col--fixed v3-actioncol v3-actionhead v3-tableview__fake-action-col"
			}, "")
		);
		for (let i = 0; i < table.tBodies.length; i++) {
			const tbody = table.tBodies[i];
			const isGroupHead = tbody.classList.contains("v3-tableview__grouphead");
			const isGroupFoot = tbody.classList.contains("v3-tableview__groupfoot");
			for (let j = 0; j < tbody.rows.length; j++) {
				const trow = tbody.rows[j];
				const firstCell = trow.cells[0];
				if (firstCell != null && (
					firstCell.classList.contains("v3-tableview__grouphead-col") ||
					firstCell.classList.contains("v3-tableview__group-col-more") ||
					firstCell.classList.contains("v3-tableview__groupfoot-col-more"))) { // th/td 
					firstCell.classList.add("v3-tableview__fake-action-colspan")
					firstCell.colSpan++;
				} else {
					trow.prepend(createElement("td", {
						width: 1,
						class: isGroupFoot ? "v3-tableview__groupfoot-col v3-tableview__groupfoot-col--fixed v3-actioncol v3-tableview__fake-action-col" :
							   !isGroupHead ? "v3-tableview__group-col v3-tableview__group-col--fixed v3-actioncol v3-tableview__fake-action-col" : null
					}));
				}
			}
		}
		callback = ((table, callback) => (success) => { cleanupFakeActionCol(table); callback?.(success); })(table, callback);
	}

	const ncols = +table.tHead?.rows[0]?.querySelectorAll("th").length;
	const newTr = createElement("tr", { "class": "v3-tableview__group-row v3-tableview__group-row--new" });
	for (let i = 0; i < ncols; i++) {
		var td = createElement("td", { class: "v3-tableview__group-col" });
		if (i === 0) {
			td.classList.add("v3-actioncol", "v3-tableview__group-col--fixed");
			td.append(createElement("nobr", { class: "v3-buttonbar" }));
		}
		newTr.append(td);
	}
	for (let i = table.tBodies.length - 1; i >= 0; i--) {
		var tbody = table.tBodies[i];
		if (!tbody.matches(".v3-tableview__grouphead,.v3-tableview__groupfoot")) {
			if (tbody.classList.contains("v3-tableview__empty")) {
				const newTbody = createElement("tbody", { class: "v3-tableview__group" }, newTr);
				tbody.after(newTbody);
				tbody.classList.add("hide");
				startEdit(newTr, url, makeStartEditCallback(newTbody, tbody, callback));
			}
			else {
				tbody.append(newTr);
				startEdit(newTr, url, makeStartEditCallback(newTr, null, callback));
			}
			return false;
		}
	}
}

function makeStartAgainCallback(table, url) {
	var callback = function (success) {
		if (success) { startNewEdit(table, url, callback); }
	};
	return callback;
}

function start(button, url, callback) {
	startEdit(button.closest("tr"), url, callback);
}

function startNew(button, url) {
	var table = button.closest("form").querySelector("table.fs-grid");
	if(table) {
		return startNewEdit(table, url, makeStartAgainCallback(table, url));
	}
}

function autoEdit(table) {
	const getFirstRow = () => table.tBodies[0].rows[0].querySelector("td");
	const getFirstButton = () => table.querySelector("[data-inline-edit-url]");
	const editButton = getFirstButton();
	const url = editButton.dataset.inlineEditUrl;
	table.addEventListener("change", () => table.querySelector(".ui-action-save").click());
	onEvent(table, "[data-inline-edit-url]", "click", () => start(getFirstRow(), url, s => s && location.reload()));
	editButton.click();
}

function init(context) {
	onEvent(context, "[data-inline-edit-new-url]", "click", (_event, button) => {
		startNew(button, button.dataset.inlineEditNewUrl);
	});
	onEvent(context, "[data-inline-edit-url]", "click", (_event, button) => {
		start(button, button.dataset.inlineEditUrl);
	});
}

export { init, start, startNew, autoEdit };